var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-accounting"},[_c('settings-navigation'),_c('team-changes-component',{attrs:{"team":"ae","startYear":"2023","startMonth":"5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }